import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useMemo } from 'react';
import { checkCancellationPreRequisites } from './check-cancellation-pre-requisites';

/**
 * - A lightweight _STEP ONE CHECK_ for cancellations journey access.
 * - It is specifically driven by posthog and policy details
 * - Full journey access should be further supported by separate eligibility checks via the cancellation API.
 *
 * IMPORTANT -
 * - DO NOT bloat this function with product based logic - `isTaxi` etc. - this is handled in the eligibility checks ([backend driven](https://dev.azure.com/IT-Developers-UK/TGG/_git/Core_Cancellation_Api?path=/src/Api.Core.Cancellation/WebAPI/Controllers/CancellationController.cs&version=GBdevelop&_a=contents)), which are outside of this function scope.
 * - The one exception to this is the `isActive` check. The BE also does this check in later API calls, but this is an edge case UX consideration for faster show/hide behaviour.
 *
 */
export const useCancellationsPreRequisites = () => {
	// Conditions derived from policy state
	const fullPolicy = useAppSelector((state) => state.fullPolicy);
	const policyToken = fullPolicy?.policyToken;
	const policyNumber = fullPolicy?.policyNumber;
	const isActive = fullPolicy?.isActive;

	// Feature flag check - to be removed post-release
	const featureFlagEnabled = !!useFeatureFlagEnabled('portal_cancellation');

	const baseAccess = useMemo(() => {
		return checkCancellationPreRequisites(featureFlagEnabled, !!isActive, policyNumber, policyToken);
	}, [policyToken, policyNumber, isActive, featureFlagEnabled]);

	return baseAccess;
};
